import { StringConstantsMixin } from '../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const ConversionsUtil = {
  METERS_TO_MILES: 0.000621371,
  milesToMeters(length, numDecimals) {
    const powerOfTen = 10 ** numDecimals;
    return Math.round((length / this.METERS_TO_MILES) * powerOfTen) / powerOfTen;
  },
  metersToMiles(length, numDecimals) {
    const powerOfTen = 10 ** numDecimals;
    return Math.round(length * this.METERS_TO_MILES * powerOfTen) / powerOfTen;
  },
  metersToFormattedUserUnits(length, displayMetric, numDecimals) {
    if (!numDecimals && numDecimals !== 0) {
      numDecimals = 2;
    }
    if (displayMetric) {
      return `${(length / 1000.0).toFixed(numDecimals)} km`;
    }
    return `${this.metersToMiles(length, numDecimals)} mi`;
  },
  minutesToFormattedTime(durationInMinutes) {
    const hours = Math.floor(durationInMinutes / 60);
    if (hours >= 12) {
      return StringConstantsMixin.strings.TIME.MULTI_DAY;
    }
    const minutes = durationInMinutes - hours * 60;
    const fmtHours = hours ? `${hours} h` : '';
    const fmtMinutes = minutes ? `${minutes} m` : '';
    return [fmtHours, fmtMinutes].filter(v => v !== '').join(' ');
  }
};

export { ConversionsUtil };
